import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zoom-out",
  "use": "zoom-out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"zoom-out\"><path d=\"M23.4,21.2l-4.68-4.71a10.26,10.26,0,0,0,2-6.07,10.43,10.43,0,1,0-4.29,8.41l4.66,4.7a1.63,1.63,0,0,0,1.16.48h0a1.65,1.65,0,0,0,1.17-2.8Zm-6-10.79a7.12,7.12,0,1,1-7.12-7.12A7.13,7.13,0,0,1,17.41,10.41Z\" /><path d=\"M14.19,9.31H6.52a1.1,1.1,0,0,0,0,2.19h7.67a1.1,1.1,0,1,0,0-2.19Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol